import React from 'react';

type ConfirmDialogProps = {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  type?: 'danger' | 'warning' | 'info';
};

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  type = 'danger',
}) => {
  if (!isOpen) return null;

  const colors = {
    danger: { bg: '#dc2626', hover: '#b91c1c' },
    warning: { bg: '#f59e0b', hover: '#d97706' },
    info: { bg: '#1fa2ff', hover: '#0b4d99' },
  };

  const color = colors[type];

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 35, 95, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        backdropFilter: 'blur(4px)',
      }}
      onClick={onCancel}
    >
      <div
        style={{
          background: 'var(--neutral-100)',
          borderRadius: 16,
          padding: 0,
          maxWidth: 420,
          width: '90%',
          boxShadow: '0 24px 60px rgba(15, 35, 95, 0.2)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '24px 24px 16px' }}>
          <h3 style={{ margin: '0 0 12px', fontSize: '1.25rem', fontWeight: 600, color: 'var(--neutral-900)' }}>
            {title}
          </h3>
          <p style={{ margin: 0, color: 'var(--neutral-700)', lineHeight: 1.6, fontSize: '0.95rem' }}>{message}</p>
        </div>
        <div
          style={{
            padding: '16px 24px 24px',
            display: 'flex',
            gap: 12,
            justifyContent: 'flex-end',
            borderTop: '1px solid rgba(15, 35, 95, 0.08)',
          }}
        >
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            style={{ width: 'auto', marginTop: 0, padding: '10px 18px' }}
          >
            {cancelText}
          </button>
          <button
            className="btn"
            onClick={onConfirm}
            style={{
              width: 'auto',
              padding: '10px 18px',
              background: type === 'danger' ? color.bg : undefined,
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

